export const MAX_SELECTED_THREADS_NUMBER = 15;

export const THREAD_CATEGORY_COLORS = {
    rose: 'fb7185',
    pink: 'f472b6',
    fuchsia: 'e879f9',
    violet: 'a78bfa',
    blue: '60a5fa',
    sky: '38bdf8',
    emerald: '34d399',
    lime: 'a3e635',
    amber: 'fbbf24',
    orange: 'fb923c',
    slate: '94a3b8',
} as const;

export const THREAD_CATEGORY_COLORS_OPTIONS: { label: string; value: string }[] = Object.entries(
    THREAD_CATEGORY_COLORS
).map(([label, value]) => ({ label, value }));

export const THREAD_SECTIONS = [
    { value: 'needs_action', label: 'Needs Action', color: 'rose', badgeColor: 'rose' },
    { value: 'follow_up', label: 'Follow-up Recommended', color: 'amber', badgeColor: 'amber' },
    { value: 'awaiting_reply', label: 'Awaiting Reply', color: 'sky', badgeColor: 'sky' },
    { value: 'snoozed', label: 'Snoozed', color: 'slate', badgeColor: 'slate' },
    { value: 'completed', label: 'Completed', color: 'emerald', badgeColor: 'success' },
    // pending omitted on purpose
    // { value: 'pending', label: 'Pending', color: 'violet', badgeColor: 'violet' },
] as const;

export type ThreadSectionValue = (typeof THREAD_SECTIONS)[number]['value'];

export const ACTIVE_THREAD_SECTIONS: { value: ThreadSectionValue; text: string }[] = [
    { value: 'needs_action', text: 'needing action' },
    { value: 'follow_up', text: 'requiring follow-up' },
    { value: 'awaiting_reply', text: 'awaiting reply' },
];
